/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { IChartItem } from 'core/models/Recharts.models';
import getEscalationSupportTotal
  from '@dashboardEscalationSupport/EscalationSupportCharts/Charts/Total/GetEscalationSupportTotal/api.service';

export interface IState {
  data: IChartItem[];
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: [],
  isLoading: false,
  error: null,
};

export const getEscalationSupportTotalAction = createAsyncThunk(
  'getEscalationSupportTotalAction',
  async ({ controller, params }: { controller: AbortController, params: TPeriod },
    { rejectWithValue }) => {
    try {
      const { signal } = controller;
      const { data } = await getEscalationSupportTotal(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const EscalationSupportTotalSlice = createSlice({
  name: 'getEscalationSupportTotal',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getEscalationSupportTotalAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEscalationSupportTotalAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getEscalationSupportTotalAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const getEscalationSupportTotalReducer = EscalationSupportTotalSlice.reducer;
